<div class="dialog-container" [style.width]="width">
  <div class="dialog-header" *ngIf="!options.hideHeader">
    <div class="dialog-header-title" *ngIf="title">
      <span class="header-title-icon" [class]="options.titleIconColor" *ngIf="options.titleIcon">
        <ui-svg-icon [svgIcon]="options.titleIcon!"></ui-svg-icon>
      </span>
      <span class="dialog-header-title-text">{{ title }}</span>
    </div>
    <ui-button
      type="transparent"
      class="close-btn"
      icon="close-cc"
      iconSize="large"
      (click)="onCancel()"
    ></ui-button>
  </div>
  <div class="dialog-content">
    <ng-content></ng-content>
  </div>
  <div class="dialog-actions">
    <ui-button
      [type]="options.cancelButtonStyle || 'secondary'"
      class="close-btn"
      [label]="options.cancelText || 'Close'"
      (click)="onCancel()"
    ></ui-button>
    <ng-container *ngIf="!options.hideConfirm">
      <ui-button
        *ngIf="!options.customConfirmButton; else customConfirmButton"
        class="confirm-btn"
        [type]="options.confirmButtonStyle || 'primary'"
        [label]="options.confirmText || 'Confirm'"
        [icon]="options.confirmIcon"
        [iconPosition]="options.confirmIconPosition || 'end'"
        (click)="onConfirm()"
      ></ui-button>
      <ng-template #customConfirmButton>
        <ng-content select="[customConfirm]"></ng-content>
      </ng-template>
    </ng-container>
  </div>
</div>
